import React, {useState} from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import plans from 'config/plans';
import { changeSubscription, updateCompany } from 'api';
import { 
  Title,
  Text,
  Button,
} from 'ui';
import './index.css';

export default function Plans(props) {
  
  const history = useHistory();
  const match = useRouteMatch();
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  
  async function selectPlan(plan) {
    if(submitting) {
      return;
    }
    setSubmitting(plan.id);
    
    try {
      await changeSubscription({
        companyId: match.params.companyId,
        planId: plan.id,
      });
      await updateCompany(match.params.companyId, {plan});
    }
    catch(error) {
      console.error(error);
      setError(error.message || "Something went wrong. Please try again.");
      setSubmitting(false);
      return;
    }
    history.push('view');
  }
  
  return (
    <div className="company-plan">
      <Title className="company-plan-title">Monthly subscriptions for all<br/>business sizes</Title>
      
      <Text color="red" className="company-plan-error">{error || ""}</Text>
      
      <div className="company-plan-3col">
        {plans.map(plan => 
          <div className="company-plan-card" key={plan.id}>
            <Title>
              {plan.name}<br/>
              ${plan.cost/100}/{plan.cycle}
            </Title>
            <ul>
              {plan.features.map((feature, i) => 
                <li key={i}><Text small>{feature}</Text></li>
              )}
            </ul>
            <Button className="company-plan-button" onClick={() => selectPlan(plan)}>
              {submitting === plan.id ? "SUBMITTING..." : "SELECT"}
            </Button>
          </div>
        )}
      </div>
      
      <Title block>Custom Enterprise &ndash;</Title>
      <a href="mailto:info@taptivate.co" style={{display:'block', textDecoration:'none'}}>
        <Text block small>
          Your national or global enterprise has a highly specific set of requirements.<br/>
          Please email us at <Text small orange>info@taptivate.co</Text> to discuss your needs.
        </Text>
      </a>
    </div>
  );
}